/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { AcceptClientLegalDocumentsRequest } from '@Model';
import type { HttpActions, ResponseResolver } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ClientController.
 */
export class ClientRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /clients/{clientId}:accept_legal_documents
     */
    public acceptClientLegalDocuments<TResponse = unknown>(clientId: string, request: AcceptClientLegalDocumentsRequest, responseResolver?: ResponseResolver<TResponse>): Promise<TResponse> {
        return this.http.post<TResponse, AcceptClientLegalDocumentsRequest>(`/clients/${clientId}:accept_legal_documents`, request, undefined, responseResolver);
    }
}
